import React from "react";
import Modal from "react-modal";
import { Button } from "@/components/Button/Button";
import { AlertTriangle } from "lucide-react";

interface LowProspectCountWarningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  lowProspectZipCodes: Array<{
    code: string;
    selectedProspects: number;
  }>;
}

const LowProspectCountWarningModal: React.FC<
  LowProspectCountWarningModalProps
> = ({ isOpen, onClose, onConfirm, lowProspectZipCodes }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
          width: "calc(100% - 32px)",
          maxWidth: "500px",
          minBlockSize: "fit-content",
          overflowY: "auto",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Low Prospect Count Warning
      </h3>

      <div className="mt-4 flex items-center gap-3">
        <AlertTriangle className="h-6 w-6 text-amber-500 flex-shrink-0" />
        <p className="text-sm text-gray-600">
          To qualify for campaign discounts, each postal code must have a
          minimum of 150 prospects selected.
        </p>
      </div>

      <p className="mt-3 text-sm text-gray-600">
        The following postal codes have less than 150 prospects selected:
      </p>

      <div className="mt-3 bg-amber-50 border border-amber-200 rounded-lg p-3 max-h-32 overflow-y-auto">
        <div className="space-y-1">
          {lowProspectZipCodes.map((zipCode) => (
            <div className="flex justify-between text-sm" key={zipCode.code}>
              <span className="font-medium">{zipCode.code}</span>
              <span className="text-amber-700">
                {zipCode.selectedProspects} prospects
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-3">
        <Button className="w-full sm:w-auto" onClick={onClose} variant="plain">
          Cancel
        </Button>
        <Button
          className="w-full sm:w-auto"
          onClick={onConfirm}
          variant="default"
        >
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default LowProspectCountWarningModal;
